module.exports = __webpack_public_path__ + "a89cc8d3c398f3d1866708995455502d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/hoodie-finger-heart-white-s.png
// module id = 1913
// module chunks = 0